import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ChatAppPaneHeaderComponent } from './routes/chat-app-pane-header.component';

/** Pieces shared by the eager shell and the lazy panes. Declaration-only. */
@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule],
  declarations: [ChatAppPaneHeaderComponent],
  exports: [ChatAppPaneHeaderComponent],
})
export class ChatAppCommonModule { }
